<div class="cw-flex-row">
    <phscw-global-help-buttons></phscw-global-help-buttons>
    <phscw-global-help-search></phscw-global-help-search>
</div>
